import { useState } from "react";
import { Modal as MantineModal, useMantineTheme } from "@mantine/core";
import {
  ETypeInstrument,
  IListPredictive,
  IPredictiveProduct,
  IPredictiveProductInstrument,
} from "../../../../hooks/usePredictives";
import { PredictiveBuyCard } from "../../../../components";

export interface ISelectedOption {
  data: IListPredictive;
  selected: { id: number; side: ETypeInstrument };
}

interface IProps {
  isModalBuy: ISelectedOption | null;
  setIsModalBuy: React.Dispatch<React.SetStateAction<ISelectedOption | null>>;
}

/**
 * Converte IListPredictive para IPredictiveProduct
 * Necessário pois a listagem usa interface diferente do detalhe
 */
function convertToProductFormat(data: IListPredictive): IPredictiveProduct {
  return {
    ...data,
    instruments: data.instruments.map(
      (instrument): IPredictiveProductInstrument => ({
        id: instrument.id,
        symbol: instrument.symbol,
        predictive_product_id: data.id,
        emphasis: false,
        created_at: data.created_at,
        updated_at: data.updated_at,
        premium: instrument.premium,
        percentage: 0,
        level1: {
          bid_price: instrument.bid_price,
          ask_price: instrument.ask_price,
        },
        level1_formatted: {
          bid_price: instrument.bid_price_formatted,
          ask_price: instrument.ask_price_formatted,
        },
        label: instrument.label,
        direction: instrument.direction,
        calculated_ask: instrument.calculated_ask,
        calculated_ask_formatted: instrument.calculated_ask_formatted,
      })
    ),
  };
}

export default function ModalBuy({ isModalBuy, setIsModalBuy }: IProps) {
  const theme = useMantineTheme();
  const [selectedSide, setSelectedSide] = useState<ETypeInstrument>(
    isModalBuy?.selected.side || ETypeInstrument.BUY
  );

  const handleClose = () => {
    setIsModalBuy(null);
  };

  // Converte dados da listagem para formato do produto
  const productData = isModalBuy?.data
    ? convertToProductFormat(isModalBuy.data)
    : undefined;

  // Encontra o instrumento selecionado
  const selectedInstrument =
    productData?.instruments.find(
      (item) => item.id === isModalBuy?.selected.id
    ) || null;

  return (
    <MantineModal
      opened={!!isModalBuy}
      onClose={handleClose}
      centered
      size="auto"
      transitionProps={{
        transition: "slide-up",
        duration: 300,
        timingFunction: "linear",
        exitDuration: 0,
      }}
      styles={{
        content: {
          borderRadius: "12px",
          boxShadow: "0px 25px 35px rgba(0, 0, 0, 0.03)",
        },
        header: {
          padding: "0",
        },
        inner: {
          background: "rgba(0, 0, 0, 0.6)",
        },
        body: {
          padding: "24px",
          maxWidth: "405px",
          color: theme.colors.basic[5],
        },
      }}
      withCloseButton={false}
    >
      <PredictiveBuyCard
        data={productData}
        selectedInstrument={selectedInstrument}
        selectedSide={selectedSide}
        onSideChange={setSelectedSide}
        variant="embedded"
        onClose={handleClose}
      />
    </MantineModal>
  );
}
